import { useState } from 'react'
import { imageUrl } from '../lib/menuImages'

/**
 * Ô ảnh của một món.
 *
 * Chưa gán ảnh, hoặc ảnh tải về hỏng, thì rơi về chữ cái đầu của tên món trong ô màu —
 * không bao giờ để một ô vỡ hình. Quán mới mở chưa gán ảnh cho món nào vẫn phải nhìn ra
 * một lưới món gọn gàng, chứ không phải một lưới ô xám.
 */
export function Thumb({
  name,
  imageKey,
  className,
}: {
  name: string
  imageKey: string | null | undefined
  className: string
}) {
  const [broken, setBroken] = useState(false)
  const src = broken ? null : imageUrl(imageKey)

  if (!src) {
    return (
      <span className={className} aria-hidden="true">
        {name.slice(0, 1)}
      </span>
    )
  }

  return (
    <span className={`${className} has-photo`} aria-hidden="true">
      <img src={src} alt="" loading="lazy" onError={() => setBroken(true)} />
    </span>
  )
}
